import { supabase } from '../config/supabaseClient.js';
import { sessao } from './auth.js';

const KEY = 'echaves:operador';
/** Operador atual no balcão = um USUÁRIO (com perfil). Padrão = o usuário logado. */
export const operadorAtual = { id: null, nome: null, perfil: null, permissoes: null };

function persist() { try { localStorage.setItem(KEY, JSON.stringify(operadorAtual)); } catch { /* ignore */ } }

export function carregarOperador() {
  try {
    const o = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (o && o.id) { operadorAtual.id = o.id; operadorAtual.nome = o.nome; operadorAtual.perfil = o.perfil || null; operadorAtual.permissoes = o.permissoes || null; }
  } catch { /* ignore */ }
}

export function definirOperador(o) {
  operadorAtual.id = o ? o.id : null;
  operadorAtual.nome = o ? o.nome : null;
  operadorAtual.perfil = o ? (o.perfil || null) : null;
  operadorAtual.permissoes = o ? (o.permissoes || null) : null;
  persist();
}

/** Operador = o próprio usuário logado (padrão ao entrar). */
export async function definirOperadorLogin() {
  let nome = 'Você';
  const dono = sessao.usuario?.colaborador_id ?? null;
  if (dono) {
    const { data: col } = await supabase.from('colaborador').select('nome').eq('id', dono).maybeSingle();
    if (col?.nome) nome = col.nome;
  }
  operadorAtual.id = sessao.usuario?.id ?? null;
  operadorAtual.nome = nome;
  operadorAtual.perfil = sessao.usuario?.perfil ?? null;
  operadorAtual.permissoes = await carregarPermissoesUsuario(sessao.usuario?.id);
  persist();
}

/** Está operando como OUTRA pessoa (operador != usuário logado)? */
export function operandoComoOutro() {
  return !!operadorAtual.id && operadorAtual.id !== (sessao.usuario?.id ?? null);
}

/** Lista usuários ATIVOS (todos são operadores) via RPC (vê todos). */
export async function listarOperadores() {
  const { data, error } = await supabase.rpc('listar_operadores');
  if (error) { console.error('[listarOperadores]', error.message); return []; }
  return (data || []).map((u) => ({ id: u.id, nome: u.nome, perfil: u.perfil, empresa: u.empresa || '', permissoes: u.permissoes || null }));
}

export async function verificarPin(id, pin) {
  const { data, error } = await supabase.rpc('verificar_pin_usuario', { p_id: id, p_pin: pin });
  if (error) { console.error('[verificarPin]', error.message); return { ok: false, precisaTrocar: false }; }
  if (typeof data === 'boolean') return { ok: data, precisaTrocar: false };
  return { ok: !!(data && data.ok), precisaTrocar: !!(data && data.precisa_trocar) };
}

/** Redefine o PRÓPRIO PIN (confirmação por senha da conta, validada no front antes). */
export async function redefinirMeuPin(pinNovo) {
  const { data, error } = await supabase.rpc('redefinir_pin_usuario', { p_pin_novo: pinNovo });
  if (error) { console.error('[redefinirMeuPin]', error.message); return false; }
  return data === true;
}

/** Busca o override de acessos de um usuario com seguranca (null se a coluna nao existir). */
async function carregarPermissoesUsuario(id) {
  if (!id) return null;
  const { data } = await supabase.from('usuario').select('permissoes').eq('id', id).maybeSingle();
  return data?.permissoes ?? null;
}

